module.exports = __webpack_public_path__ + "static/undraw_time_management_30iu-30fbb50df40be2394f9663568ab87114.svg";